import styled from 'styled-components';

export const HeaderTableWrapper = styled.div`
  text-align: left;
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.colors[props.bgColor]};
  cursor: pointer;
  height: ${props => props.height || '0px'};
  margin: ${props => props.margin || '0px'};
`;



// WEBPACK FOOTER //
// ./src/components/HeaderTable/styles.js